
import SwiperInit from './parts/swiperInit'
document.addEventListener('DOMContentLoaded', () => { 
  const ebookwebinarSelector = document.querySelectorAll('.ebookwebinar-swiper')
  const ebookwebinarSwiper = new SwiperInit({
    selector: ebookwebinarSelector,
    spaceBetween: 20,
    slidesPerView: 1,
    breakPoints: {
      280: {
        centeredSlides: true,
        slidesPerView: 1.15, 
        spaceBetween: 16
      },
      576: {
        centeredSlides: true,
        slidesPerView: 1.4, 
        spaceBetween: 16
      },
      768: {
        centeredSlides: false,
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30,
        slidesPerView: 1.9, 
        spaceBetween: 16
      },
      992: {
        centeredSlides: false,
        slidesPerView: 2.2,
        spaceBetween: 20
      },
    }
  })
})
